
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSafetyDepthProposal as ObiChartSafetyDepthProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-safety-depth-proposal.js';
 
 
 

 
 export const ObiChartSafetyDepthProposal = createComponent({
   react: React,
   tagName: 'obi-chart-safety-depth-proposal',
   elementClass: ObiChartSafetyDepthProposalElement,
   events: {
     
   }
  });
 
 